import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'dailog-modal',
  templateUrl: './dailog-modal.html',
  styleUrls: ['./dailog-modal.scss'],
})
export class dailogModal {

  @Input() pan: string;
  showLoader = false;
  @Input() ckycNo: string;
  @Input() onReturn: () => void;

  constructor() { }

  handleContinue() {
    this.showLoader = true
    if (this.onReturn) {
      this.onReturn();
    }
  }


  onCancel() {
    window.location.reload();
  }

}